/**
 * Control glyphs, redrawn as vector from the strip along the bottom of
 * docs/possible_icons.png.
 *
 * Stroke-only and unfilled so they inherit `currentColor` and work in both
 * themes without a second asset. `aria-hidden` on every one: the button around
 * the icon carries the accessible name, and a decorative glyph announcing
 * itself would just double it up.
 */

const OPEN =
  '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" ' +
  'stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';

function icon(body: string): string {
  return OPEN + body + "</svg>";
}

/** Teeth of the settings gear, eight spokes at 45-degree steps. */
const GEAR_TEETH = [
  "M18.4 12h2.2",
  "M16.53 7.47 18.08 5.92",
  "M12 5.6V3.4",
  "M7.47 7.47 5.92 5.92",
  "M5.6 12H3.4",
  "M7.47 16.53 5.92 18.08",
  "M12 18.4v2.2",
  "M16.53 16.53 18.08 18.08",
].join("");

export const icons = {
  newGame: icon('<rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/><path d="M12 3.5v17M3.5 12h17"/>'),

  notes: icon('<path d="M4 20.2l1.3-4.4L16.1 5a2 2 0 0 1 2.9 2.9L8.4 18.9 4 20.2Z"/><path d="m14.6 6.5 2.9 2.9"/>'),

  erase: icon(
    '<path d="M8.4 18.5H5.6a1.6 1.6 0 0 1-1.13-2.73l8.8-8.8a1.6 1.6 0 0 1 2.26 0l3.5 3.5a1.6 1.6 0 0 1 0 2.26l-5.77 5.77Z"/>' +
      '<path d="M20 20.5h-8.7"/><path d="m9.6 9.9 4.5 4.5"/>',
  ),

  hint: icon(
    '<path d="M9.6 17.2h4.8"/><path d="M10.4 20h3.2"/>' +
      '<path d="M12 3.6a5.4 5.4 0 0 0-3.1 9.8v1.4h6.2v-1.4A5.4 5.4 0 0 0 12 3.6Z"/>' +
      '<path d="M12 .9v1.1M4.6 4.4l.8.8M19.4 4.4l-.8.8"/>',
  ),

  undo: icon('<path d="M4.2 9.2h9.3a5.4 5.4 0 1 1 0 10.8H9.4"/><path d="m8 5.2-3.8 4 3.8 4"/>'),

  redo: icon('<path d="M19.8 9.2h-9.3a5.4 5.4 0 1 0 0 10.8h4.1"/><path d="m16 5.2 3.8 4-3.8 4"/>'),

  pause: icon('<rect x="4.5" y="4.5" width="15" height="15" rx="3"/><path d="M10 9.2v5.6M14 9.2v5.6"/>'),

  play: icon('<rect x="4.5" y="4.5" width="15" height="15" rx="3"/><path d="m10.2 8.6 5.4 3.4-5.4 3.4Z"/>'),

  settings: icon(`<circle cx="12" cy="12" r="6.4"/><circle cx="12" cy="12" r="2.6"/><path d="${GEAR_TEETH}"/>`),

  close: icon('<path d="m6 6 12 12M18 6 6 18"/>'),
} as const;

export type IconName = keyof typeof icons;
